export const services = [
  {
    id: 1,
    name: "Pressure Cleaning",
    slug: "pressure-cleaning",
    icon: "ri-water-flash-line",
    benefit: "Removes years of dirt, mold, and buildup without damaging your surfaces.",
    description: "Professional high-pressure and soft-wash cleaning for all exterior surfaces. We restore your home\'s curb appeal fast.",
    imageUrl: "https://public.readdy.ai/ai/img_res/9bcd3651e442ff76fe80bfe72d196c2a.jpg"
  },
  {
    id: 2,
    name: "Roof Cleaning",
    slug: "roof-cleaning",
    icon: "ri-home-4-line",
    benefit: "Extend your roof\'s lifespan and make it look brand new — safely.",
    description: "Soft-wash roof cleaning that eliminates black streaks, algae, and mold without voiding your warranty or damaging tiles.",
    imageUrl: "https://readdy.ai/api/search-image?query=clean%20sparkling%20terracotta%20tile%20roof%20Florida%20home%20after%20professional%20soft%20wash%20roof%20cleaning%20restoration%20gleaming%20pristine%20sky%20background&width=600&height=400&seq=svc-roof1&orientation=landscape"
  },
  {
    id: 3,
    name: "Driveway Cleaning",
    slug: "driveway-cleaning",
    icon: "ri-road-map-line",
    benefit: "Blast out oil stains, mold, and grime for a driveway that looks freshly poured.",
    description: "High-pressure driveway and walkway cleaning that removes the toughest stains and restores your concrete\'s natural color.",
    imageUrl: "https://readdy.ai/api/search-image?query=spotless%20clean%20bright%20concrete%20driveway%20Florida%20suburban%20home%20after%20professional%20pressure%20washing%20restored%20pristine%20curb%20appeal%20sunshine&width=600&height=400&seq=svc-driveway1&orientation=landscape"
  },
  {
    id: 4,
    name: "Screen Patios",
    slug: "screen-patios",
    icon: "ri-grid-line",
    benefit: "Crystal-clear screens and frames — pass your HOA inspection with ease.",
    description: "Complete screen enclosure and pool cage cleaning that removes algae, mildew, and oxidation from frames and mesh.",
    imageUrl: "https://readdy.ai/api/search-image?query=clean%20sparkling%20screen%20patio%20pool%20cage%20enclosure%20Florida%20home%20after%20professional%20pressure%20washing%20crystal%20clear%20pristine%20backyard%20swimming%20pool&width=600&height=400&seq=svc-patio1&orientation=landscape"
  },
  {
    id: 5,
    name: "Gutter Cleaning",
    slug: "gutter-cleaning",
    icon: "ri-filter-line",
    benefit: "Prevent water damage and protect your foundation — gutters cleared fast.",
    description: "Full gutter flush and debris removal to prevent water damage, roof rot, and foundation issues before they get expensive.",
    imageUrl: "https://readdy.ai/api/search-image?query=clean%20metal%20gutters%20roof%20edge%20Florida%20home%20after%20professional%20cleaning%20cleared%20debris%20bright%20clean%20white%20aluminum%20gutter%20system%20sunny%20day&width=600&height=400&seq=svc-gutter1&orientation=landscape"
  }
];
